import type { AppNotification } from "@/types";

export const notificationsList: AppNotification[] = [
  {
    id: "n0",
    type: "delivery",
    icon: "ri-e-bike-2-line",
    title: "تم تأكيد توصيل الطلب #1045",
    body: "أكّد المندوب تسليم الطلب #1045 للعميل ماجد العنزي من فرع العليا عبر «توصيل بواسطة المحل». تذكير: راجع حالة الطلب وأغلقه إن كان مكتملًا.",
    time: "منذ 40 دقيقة",
    isRead: false,
    orderId: "1045",
  },
  {
    id: "n1",
    type: "financial",
    icon: "ri-money-dollar-circle-line",
    title: "تنبيه رسوم التطبيق لطلبات الكاش",
    body: "بلغ رصيد رسوم التطبيق المستحقة لطلبات الكاش 384.00 ريال. يرجى السداد لإعادة تفعيل استقبال الطلبات النقدية.",
    time: "منذ ساعتين",
    isRead: false,
  },
  {
    id: "n2",
    type: "rating",
    icon: "ri-star-line",
    title: "تقييم جديد",
    body: "قيّم العميل سعد الحربي فرع العليا بـ 5 نجوم: «الطعام وصل ساخنًا وسريعًا».",
    time: "منذ 4 ساعات",
    isRead: false,
  },
  {
    id: "n3",
    type: "store",
    icon: "ri-store-2-line",
    title: "تم تفعيل فرع الملقا",
    body: "تمت الموافقة على تفعيل فرع الملقا من قبل الإدارة وأصبح متاحًا لاستقبال الطلبات.",
    time: "أمس",
    isRead: false,
  },
  {
    id: "n4",
    type: "system",
    icon: "ri-megaphone-line",
    title: "إشعار نظامي",
    body: "تمت إضافة ميزة «تقييم العملاء بعد إتمام الطلب» إلى لوحة الكاشير.",
    time: "منذ يومين",
    isRead: false,
  },
  {
    id: "n5",
    type: "financial",
    icon: "ri-refund-2-line",
    title: "تمت تسوية طلب محفظة",
    body: "تم تحويل 1,250.00 ريال من طلبات المحفظة إلى حسابك البنكي المسجّل.",
    time: "منذ 3 أيام",
    isRead: true,
  },
  {
    id: "n6",
    type: "system",
    icon: "ri-shield-check-line",
    title: "تحديث الشروط",
    body: "تم تحديث سياسة التسوية المالية. يمكنك مراجعتها من قسم المعاملات المالية.",
    time: "منذ 5 أيام",
    isRead: true,
  },
];